import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ExternalLink } from "lucide-react";

export default function PresentationLanding() {
  const [projects, setProjects] = useState([]);
  const [copiedId, setCopiedId] = useState(null);
  useEffect(() => { api.get("/projects").then(({ data }) => setProjects(data)); }, []);
  const sortedProjects = [...projects].sort((a, b) => {
    const aHasCover = Boolean((a.cover_image_url || "").trim());
    const bHasCover = Boolean((b.cover_image_url || "").trim());
    if (aHasCover !== bHasCover) return aHasCover ? -1 : 1;
    return (a.name || "").localeCompare(b.name || "", "tr");
  });

  return (
    <div className="space-y-6" data-testid="presentation-landing">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 font-display">Sunum Ekranı</h1>
        <p className="text-slate-500 mt-1">Müşteriye göstermek için sunumda açın veya paylaşılabilir link kopyalayın.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
        {sortedProjects.map((p) => (
          <div key={p.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden flex flex-col h-fit">
            {p.cover_image_url ? (
              <div className="h-56 md:h-64 xl:h-[280px] bg-slate-100 border-b border-slate-100 shrink-0">
                <img src={p.cover_image_url} alt={p.name} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="h-56 md:h-64 xl:h-[280px] bg-slate-100 flex items-center justify-center border-b border-slate-100 shrink-0">
                <div className="text-center px-6">
                  <div className="text-sm font-semibold text-slate-500">Görsel eklenmemiş</div>
                  <div className="text-xs text-slate-400 mt-1">Proje düzenleme ekranından kapak görseli ekleyebilirsiniz.</div>
                </div>
              </div>
            )}
            <div className="p-5 flex flex-col">
              <div>
                <div className="text-lg font-semibold text-slate-900">{p.name}</div>
                <div className="text-xs text-slate-500">{p.location}</div>
              </div>
              <div className="mt-4 flex gap-2 flex-wrap">
                <Link to={`/p/projects/${p.id}`} target="_blank"
                      className="px-3 py-1.5 text-sm bg-amber-500 hover:bg-amber-600 text-white rounded-lg inline-flex items-center gap-1"
                      data-testid={`open-presentation-${p.id}`}>
                  <ExternalLink className="w-4 h-4" /> Sunumda Aç
                </Link>
                <button onClick={() => {
                  navigator.clipboard.writeText(`${window.location.origin}/p/projects/${p.id}`);
                  setCopiedId(p.id);
                  setTimeout(() => setCopiedId(null), 1400);
                }} className="px-3 py-1.5 text-sm bg-white border border-slate-200 rounded-lg">
                  {copiedId === p.id ? "Kopyalandı" : "Bağlantıyı Kopyala"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
